// src/components/TopNav.jsx
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import CompassLogo from "components/icons/CompassLogo";
import { useProfile } from "context/ProfileContext";

export default function TopNav() {
  const { profile } = useProfile();

  const initials = useMemo(() => {
    const first = profile?.first_name?.trim()?.[0] || "";
    const last = profile?.last_name?.trim()?.[0] || "";
    return (first + last).toUpperCase() || "?";
  }, [profile]);

  return (
    <header className="bar-brand border-b border-app sticky top-0 z-40">
      <div className="w-full px-4 py-1 flex items-center">
        <div className="flex items-center gap-1">
          <CompassLogo
            className="h-8 w-8 text-brand1-foreground select-none"
            strokeWidth={1.8}
          />
          <span className="text-base md:text-lg font-semibold tracking-wide text-brand1-foreground">
            CoreCompass™
          </span>
        </div>

        <div className="ml-auto flex items-center justify-end gap-2 sm:gap-3 min-w-0">
          <Link
            to="/user-profile"
            className="shrink-0 p-1"
            aria-label="View/Edit User Profile"
            title="View/Edit User Profile"
          >
            <div
              className="
                h-9 w-9 rounded-full
                flex items-center justify-center
                font-semibold text-sm
                bg-app text-app
                border-[3px] border-app
                transition-colors
                hover:border-brand
                focus-visible:ring-2 focus-visible:ring-muted
              "
            >
              {initials}
            </div>
          </Link>
        </div>
      </div>
    </header>
  );
}
